import script from "./commission.vue?vue&type=script&setup=true&lang=js"
export * from "./commission.vue?vue&type=script&setup=true&lang=js"

import "./commission.vue?vue&type=style&index=0&id=6615a072&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\payment-system-agent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6615a072"]])

export default __exports__